import React from 'react';

import { Attribution, withTransparentErrorBoundary } from '@confluence/error-boundary';

export const HomeBanner = () => {
	return (
		<div role="banner" aria-label="Post Office banner placement">
			Post Office Banner placeholder
		</div>
	);
};

export const PostOfficeHomeBanner = withTransparentErrorBoundary({
	attribution: Attribution.POST_OFFICE,
})(HomeBanner);
